import { render, staticRenderFns } from "./FeedItemDetails.vue?vue&type=template&id=24e84569&scoped=true&"
import script from "./FeedItemDetails.vue?vue&type=script&lang=js&"
export * from "./FeedItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemDetails.vue?vue&type=style&index=0&id=24e84569&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e84569",
  null
  
)

export default component.exports